import MainComponent from "./components/MainComponent.jsx";

function App() {
  return (
    <div>
      <MainComponent />
    </div>
  );
}

export default App;
